import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { Cancellation as CancellationIndex, CancellationSuccess } from '../../../../components/Appointment'

const Cancellation = () => (
  <Routes>
    <Route element={<CancellationIndex />} path="/" />
    <Route element={<CancellationSuccess />} path="success" />
    <Route element={<NotFound />} path="*" />
  </Routes>
)

export { Cancellation }
